import React, { useEffect, useState } from "react";

import { apiCallSPDelete, apiCallSPPost } from "src/_apiConfig/apiCall";
import ToastMessage from "src/_components/ToastMessage";
import {
  addToastError,
  addToastSuccess,
  AlertResponse,
} from "src/_constants/alert.type";
import Auth from "src/auth";
import CommonList from "src/views/common/CommonList";
import {
  CommonSearchExtra,
  SCAddButton,
  SCInput,
  updateSearchStatus,
} from "src/views/common/CommonSearch";
import ConfirmationPopup from "src/views/common/ConfirmationPopup";
import TableButtonClick from "src/views/common/Table/TableButtonClick";
import TableButtonTo from "src/views/common/Table/TableButtonTo";
import TableDateFromat from "src/views/common/Table/TableDateFromat";

const GoDownFeesExtensionList = () => {
  const { authenticated } = Auth();
  const [usersData, setUserData] = useState(); // List data manage
  const [pageCount, setPageCount] = useState(0); // List Data pagging manage
  const [loading, setloading] = useState(false); // page loading
  const [pageLimit, setpageLimit] = useState(0); // pageing index manage
  const [itemPerPage, setItemPerPage] = useState(10); // Record Show Each Page
  const [disabledprev, setdisabledprev] = useState(false); //Pagging Prev. Button disabled manage;
  const [disablednext, setdisablednext] = useState(false); //Pagging Next Button disabled manage;
  const [isSearch, setIsSearch] = useState(false); // Search Button Effect Manage
  const [isClear, setIsClear] = useState(false); // Clear Button Effect Manage
  // const [textField, settextField] = useState("tenderNo"); // table header Default Selected Column
  // const [order, setorder] = useState("asc"); // table header Default Selected Column order Set
  // const [orderClick, setOrderClick] = useState(true); // table header orderClick Column manage
  const [toasts, setToasts] = useState(AlertResponse);

  //Confirmation popup------------------------------------
  const [CPopUpId, setCPopUpId] = useState();
  const [CPopUpIndex, setCPopUpIndex] = useState();
  const [CPopUpDisplayConfirmationModal, setCPopUpDisplayConfirmationModal] =
    useState(false);
  const [CPopUpBodyText, setCPopUpBodyText] = useState();
  // adding button loader
  const [ButtonLoader, SetButtonLodaer] = useState(false);

  const handleConfirmationPopUpModalClose = () =>
    setCPopUpDisplayConfirmationModal(false);
  //-------------------------------------------------------
  const ConfirmationPopupHandler = async (
    popupid,
    popupindex,
    popupbodytext
  ) => {
    setCPopUpId(popupid);
    setCPopUpIndex(popupindex);
    setCPopUpDisplayConfirmationModal(true);
    setCPopUpBodyText(popupbodytext);
  };

  // // Your default search model
  const SearchFilterModel = {
    tenderNo: "",
    lotNo: "",
    date: "",
  };

  const [search, setSearch] = useState(SearchFilterModel); // Search Manage

  useEffect(() => {
    setloading(true);
    resetPageLimit();
    getPageCount();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated]);

  useEffect(() => {
    if (isSearch === false) {
      getGoDownRentFeeExtensionList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated, pageLimit, itemPerPage]);

  useEffect(() => {
    if (isSearch) {
      getPageCount();
      getGoDownRentFeeExtensionList();
      setIsClear(false);
      setIsSearch(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSearch, itemPerPage]);

  //Pagging Disabled /Enable manage
  const paggingDisabled = (isNext = true, isPrev = true) => {
    setdisablednext(isNext);
    setdisabledprev(isPrev);
  };
  //Pagging manage
  const paggingManage = (totalRecord, isRecordGet = true) => {
    setPageCount(parseInt(totalRecord) || 0);
    paggingDisabled(
      pageLimit >= parseInt(totalRecord) - parseInt(itemPerPage),
      pageLimit === 0
    );
  };

  // api data manage
  const getdata = (setPageLimits = "", setItemPerPages = "") => {
    return JSON.stringify({
      start: setPageLimits === "" ? pageLimit : setPageLimits,
      length: setItemPerPages === "" ? itemPerPage : setItemPerPages,
      tenderNo: search.tenderNo.trim(),
      lotNo: search.lotNo.trim(),
      districtId: authenticated.district,
      //date: search.date,
    });
  };

  const getPageCount = async () => {
    if (authenticated) {
      await apiCallSPPost(
        `GoDownRentFeeExtension/List/count`,
        getdata(),
        0
      ).then((res) => {
        if (res.success) paggingManage(parseInt(res.totalRecord) || 0);
      });
    }
  };
  const getGoDownRentFeeExtensionList = async () => {
    if (authenticated) {
      setloading(true);
      paggingDisabled();
      setUserData();

      await apiCallSPPost("GoDownRentFeeExtension/List", getdata(), [])
        .then((res) => {
          if (res.success) {
            setUserData(res.data);

            if (isSearch === false && pageLimit >= 0 && pageCount > 0) {
              paggingManage(pageCount);
            }
          } else {
            setUserData();
            paggingManage(0, false);
            alert(res.message);
          }
        })
        .finally(() => {
          setloading(false);
        });
    }
  };

  const resetPageLimit = (pageLimit) => {
    setpageLimit(pageLimit || 0);
  };

  // Pagging Prev. Button Click Event
  const prevButton = () => {
    let pageLimitSet = parseInt(pageLimit) - parseInt(itemPerPage);
    pageLimitSet = pageLimitSet < 0 ? 0 : pageLimitSet;
    resetPageLimit(pageLimitSet);
  };
  // Pagging Next Button Click Event
  const nextButton = () => {
    let pageLimitSet = parseInt(pageLimit) + parseInt(itemPerPage);
    pageLimitSet =
      pageLimitSet >= parseInt(pageCount) ? parseInt(pageCount) : pageLimitSet;
    resetPageLimit(pageLimitSet);
  };

  const SubmitConfirmationPopUpResponse = async () => {
    //ApproveApiCall(CPopUpId);
    SetButtonLodaer(true);
    const data = JSON.stringify({
      id: CPopUpId,
      insertedBy: authenticated.userId,
    });
    await apiCallSPDelete("GoDownRentFeeExtension/delete", data, 0)
      .then(async (res) => {
        if (res.success) {
          console.log("handleSubmit : ", res);
          resetPageLimit();
          setIsSearch(true);
          addToastSuccess(setToasts, res.message);
          handleConfirmationPopUpModalClose();
        } else {
          addToastError(setToasts, res.message, 0);
        }
      })
      .finally(() => {
        SetButtonLodaer(false);
      });
  };

  let scopedSlotsList = {
    startDatedateformat: (item, index) => {
      return TableDateFromat(item.startDate);
    },
    enddateformat: (item, index) => {
      return TableDateFromat(item.endDate);
    },
    editbtn: (item, index) => {
      let id = item.id;

      return (
        <TableButtonTo
          isDisplayAllow={item.status !== "Success"}
          to={"/GoDownFeesExtension/Edit/" + id}
          ButtonName={"Edit"}
        />
      );
    },
    deleteBtn: (item, index) => {
      // {showbtn(props.isAllowToCCFDeleteTheBidderAgreement,item.fileName.toLowerCase())}

      return (
        <TableButtonClick
          isDisplayAllow={item.status !== "Success"}
          buttonName={"Delete"}
          color={"danger"}
          onClick={(e) =>
            ConfirmationPopupHandler(
              item.id,
              -1,
              "Are you sure you want to Delete?"
            )
          }
        />
      );
    },
  };
  let fields = [
    {
      key: "srNo",
      _style: { width: "5%" },
      label: "S.N.",
    },
    {
      key: "tenderNo",
      _style: { width: "10%" },
      label: "Tender No",
    },
    {
      key: "lotNo",
      _style: { width: "10%" },
      label: "Lot No",
    },
    {
      key: "amount",
      _style: { width: "10%" },
      label: "Amount",
    },

    {
      key: "startDatedateformat",
      _style: { width: "10%" },
      label: "Start Date",
    },
    {
      key: "enddateformat",
      _style: { width: "10%" },
      label: "End Date",
    },
    {
      key: "insertdateformat",
      _style: { width: "10%" },
      label: "Created Date",
    },
    {
      key: "insertedByUser",
      _style: { width: "15%" },
      label: "Created By",
    },
    {
      key: "editbtn",
      _style: { width: "5%" },
      label: "Edit",
    },
    {
      key: "deleteBtn",
      _style: { width: "5%" },
      label: "Delete",
    },
  ];

  // Search Model Value Update Manage
  const updateSearch = (e, name = "", value = "") => {
    updateSearchStatus(setSearch, search, e, name, value);
  };
  // item per page  onChanage Event
  const onChangePage = (ev) => {
    ev.preventDefault();
    setpageLimit(0);
    setItemPerPage(ev.target.value);
    setIsSearch(true);
    paggingManage(pageCount);
  };

  // Search Button Click Event
  const searchButton = (ev) => {
    ev.preventDefault();
    resetPageLimit();
    setIsSearch(true);
  };

  //Clear Button Click Event
  const clearSearch = (ev) => {
    ev.preventDefault();
    resetPageLimit();
    setIsClear(true);
    setIsSearch(true);
    setSearch({ ...search, ...SearchFilterModel });
    setUserData([]);
  };

  const searchControl = (
    <>
      <SCInput
        label={"Lot No :"}
        name={"lotNo"}
        value={search.lotNo}
        onChange={updateSearch}
      />
    </>
  );
  let additional = (
    <CommonSearchExtra
      isDisabledSearchClear={loading}
      extraControl={searchControl}
      isClear={isClear}
      search={search}
      updateSearch={updateSearch}
      searchButton={searchButton}
      clearSearchButton={clearSearch}
      itemPerPage={itemPerPage}
      onChangePage={onChangePage}
      extraSearchControl={<SCAddButton tourl={"/GoDownFeesExtension/Add"} />}
    />
  );

  return (
    <>
      <ToastMessage toasts={toasts} setToasts={setToasts} />
      <CommonList
        items={usersData}
        fields={fields}
        listName="GoDown Fees Extension"
        loading={loading}
        prev={prevButton}
        next={nextButton}
        disabledprev={disabledprev}
        disablednext={disablednext}
        additional={additional}
        path={`/GoDownFeesExtension/Edit/`}
        tabBtn="Edit"
        id="id"
        scopedSlots={scopedSlotsList}
      />
      <ConfirmationPopup
        showModal={CPopUpDisplayConfirmationModal}
        hideModal={handleConfirmationPopUpModalClose}
        confirmModal={SubmitConfirmationPopUpResponse}
        id={CPopUpId}
        index={CPopUpIndex}
        ModalBody={CPopUpBodyText}
        // ModalTitle={CPopUpTitle}
        confirmButtonCss="btn btn-danger"
        ButtonLoader={ButtonLoader}
      />
    </>
  );
};
export default GoDownFeesExtensionList;
